module.exports = __webpack_public_path__ + "media/images/illustrations/coins-falling-coin-f4fd93d0c78584939a7953a8d35f86a1.svg";